module.exports = __webpack_public_path__ + "img/@ico_more.2ac38a59.svg";